import { useCallback, useState } from "react";
import { useLocation } from "react-router-dom";

import { moreHoldsCurrent, type MoreGroup } from "../navigation";
import { NavMenu } from "./NavMenu";

/**
 * The More menu of the bar: every older screen that no view has replaced yet, in its groups. The menu is open for the screen it
 * was opened on, so going to another screen closes it without an effect.
 */
export function MoreMenu({ groups }: { groups: readonly MoreGroup[] }) {
  const { pathname } = useLocation();
  const [openedOn, setOpenedOn] = useState<string | null>(null);
  const open = openedOn === pathname;
  const close = useCallback(() => setOpenedOn(null), []);
  if (groups.length === 0) return null;
  return (
    <NavMenu
      label="More"
      summary="The other screens"
      groups={groups}
      current={moreHoldsCurrent(groups, pathname)}
      open={open}
      onOpen={() => setOpenedOn(pathname)}
      onClose={close}
    />
  );
}
